import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

import { map } from "rxjs/operators";
import { ILanguage } from "../../models";
import { environment } from "src/environments/environment";
@Injectable({
  providedIn: "root",
})
export class LanguageListService {
  constructor(private http: HttpClient) {}

  // function 'get's a list of International Languages from the API
  getLanguageList = (): Observable<ILanguage[]> => {
    return (
      this.http
        .get(`${environment.apiUrl}/getLanguageCodes`)
        // Getting the array of languages from the QasData Container
        .pipe(map((response) => response["QasData"])) as Observable<ILanguage[]>
    );
  };
}
